import React, {useState} from 'react';
import {validateEmail, checkAustralianPhone } from '../../utils/helpers';


function ContactForm(){

    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [errorMessage, setErrorMessage] = useState('');

    const handleInputChange = (e) => {
        // Getting the value and name of the input which triggered the change
        setErrorMessage('');
        const { target } = e;
        const inputType = target.name;
        const inputValue = target.value;
    
        // Based on the input type, we set the state of either email, username, and password
        if (inputType === 'email') {
            setEmail(inputValue);
        } else if (inputType === 'firstName') {
            setFirstName(inputValue);
        } else if (inputType === 'lastName') {
            setLastName(inputValue);
        } else {
            setPhone(inputValue);
        }
    };

    const handleFormSubmit = (e) => {
        // Preventing the default behavior of the form submit (which is to refresh the page)
        e.preventDefault();
        
    
        // First we check to see if the email is not valid or if the userName is empty. If so we set an error message to be displayed on the page.
        if (!validateEmail(email)) {
            setErrorMessage('First Name, Last Name or Email is invalid');
          // We want to exit out of this code block if something is wrong so that the user can correct it
            return;
          // Then we check to see if the password is not valid. If so, we set an error message regarding the password.
        }
        if (!checkAustralianPhone(phone)) {
            setErrorMessage( `Please enter a valid Australian Number`);
            return;
        }
    
        // If everything goes according to plan, we want to clear out the input after a successful registration.
        setFirstName('');
        setLastName('');
        setEmail('');
        setPhone('');
    };

    return (
        <>
            <section id="about-contact" className="wrapper">
                <div className="contact-box panel"><i className="fas fa-envelope-square"></i><p>leonhsu95@gmail.com</p></div>
                <div className="contact-box panel"><i className="fab fa-github"></i><p>leonhsu95</p></div>
            </section>

            <section id="contact" className="link-section responsive">
                <div className="wrapper">
                    <h2 id="contact-heading" className="section-heading">Contact Me</h2>
                    <form id="contact-form" action="send" noValidate="">
                    {errorMessage && (
                            <div>
                                <p className="error-message">{errorMessage}</p>
                            </div>
                        )}
                        <div id="success"></div>
                        <fieldset>
                            <p className="form-fields">
                                <label htmlFor="firstName">First Name:</label>
                                <input type="text" name="firstName" id="firstName" className="text-input" value={firstName} onChange={handleInputChange}></input>
                            </p>
                            <p className="form-fields">
                                <label htmlFor="lastName">Last Name:</label>
                                <input type="text" name="lastName" id="lastName" className="text-input" value={lastName} onChange={handleInputChange}></input>
                                
                            </p>
                            <p className="form-fields">
                                <label htmlFor="phone">Phone:</label>
                                <input type="text" name="phone" id="phone" className="text-input" value={phone} onChange={handleInputChange}></input>
                            </p>
                            <p className="form-fields">
                                <label htmlFor="email">Email:</label>
                                <input type="email" name="email" id="email" className="text-input" placeholder="example@email.com" value={email} onChange={handleInputChange}></input>
                            </p>
                            <p className="form-comment">
                            <label htmlFor="comment" className="textlabel">Comment:</label>
                            <textarea name="comment" id="comment" rows="6"></textarea>
                            </p>
                            <p className="form-submit">
                            <button type="submit" id="submit" onClick={handleFormSubmit}>Submit</button>
                            </p>
                        </fieldset>
                        
                    </form>
                </div>     
            </section>
        </>    
    )
}

export default ContactForm;